import Vue from 'vue'
import Router from 'vue-router'
import Axios from 'axios'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}

import Login from '@/components/login/Login.vue'
import Register from '@/components/register/Register.vue'
import UsernameAndPassword from '@/components/register/UsernameAndPassword.vue'
import RegisterSuccess from '@/components/register/Success.vue'
import RealName from '../components/register/Realname.vue'
import RealNameSuccess from '../components/register/RealnameSuccess.vue'
import TeacherAgreement from '../components/teacher/TeacherAgreement.vue'
import TeacherInfo from '../components/teacher/TeacherInfo.vue'
import TeacherCert from '../components/teacher/TeacherCert.vue'
import JoinSchool from '../components/user/JoinSchool.vue'
import TeacherSuccess from '../components/teacher/TeacherSuccess.vue'
import UserCenter from '../components/user/UserCenter.vue'
import BindAndPassword from '../components/user/BindAndPassword.vue'
import UserRealname from '../components/user/UserRealname.vue'
import UserRealnameResult from '../components/user/UserRealnameResult.vue'
import UserTeacherCer from '../components/user/UserTeacherCer.vue'
import UserJoinSchool from '../components/user/UserJoinSchool.vue'
import UserSetting from '../components/user/UserSetting.vue'
import UserTeacherAgreement from '../components/user/UserTeacherAgreement.vue'
import UserTeacherInfo from '../components/user/UserTeacherInfo.vue'
import GetBackPassword from '../components/login/GetBackPassword'
import SetNewPassword from '../components/login/SetNewPassword'
import Error from '../components/Error'
import RegisterEmail from '../components/register/RegisterEmail'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/register',
            name: 'register',
            component: Register
        },
        {
            path: '/register-user',
            name: 'usernameAndPassword',
            component: UsernameAndPassword
        },
        {
            path: '/register-success',
            name: 'registerSuccess',
            component: RegisterSuccess
        },
        {
            path: '/register-realname',
            name: 'registerRealname',
            component: RealName
        },
        {
            path: '/register-realname-success',
            name: 'registerRealnameSuccess',
            component: RealNameSuccess
        },
        {
            path: '/teacher-agreement',
            name: 'teacherAgreement',
            component: TeacherAgreement
        },
        {
            path: '/teacher-info',
            name: 'teacherInfo',
            component: TeacherInfo
        },
        {
            path: '/teacher-cert',
            name: 'teacherCert',
            component: TeacherCert
        },
        {
            path: '/join-school',
            name: 'joinSchool',
            component: JoinSchool
        },
        {
            path: '/teacher-success',
            name: 'teacherSuccess',
            component: TeacherSuccess
        },
        {
            path: '/user-center',
            name: 'userCenter',
            component: UserCenter
        },
        {
            path: '/bind-and-password',
            name: 'bindAndPassword',
            component: BindAndPassword
        },
        {
            path: '/user-realname',
            name: 'userRealname',
            component: UserRealname
        },
        {
            path: '/user-realname-result',
            name: 'userRealnameResult',
            component: UserRealnameResult
        },
        {
            path: '/user-teacher-cer',
            name: 'userTeacherCer',
            component: UserTeacherCer
        },
        {
            path: '/user-teacher-agreement',
            name: 'userTeacherAgreement',
            component: UserTeacherAgreement
        },
        {
            path: '/user-join-school',
            name: 'userJoinSchool',
            component: UserJoinSchool
        },
        {
            path: '/user-setting',
            name: 'userSetting',
            component: UserSetting
        },
        {
            path: '/user-teacher-info',
            name: 'userTeacherInfo',
            component: UserTeacherInfo
        },
        {
            path: '/get-back-password',
            name: 'getBackPassword',
            component: GetBackPassword
        },
        {
            path: '/set-new-password',
            name: 'setNewPassword',
            component: SetNewPassword
        },
        {
            path: '/error',
            name: 'error',
            component: Error
        },
        {
            path: '/register-email',
            name: 'registerEmail',
            component: RegisterEmail
        }
    ]
})

/**
 * 路由导航守卫
 */
router.beforeEach((to, from, next) => {
    // NProgress.start()
    console.log('to.path:', to.path)
    let serverUrl = localStorage.getItem('ServerUrl')
    if (to.path === '/register-email') {
        //判断是否可以email注册
        Axios.get(serverUrl + '/api/configsystem/getbyname', {
            params: {
                name: 'register_type'
            }
        }).then(function (r) {
            if (r.data.data.value === 2) {
                //允许邮箱注册
                next()
            } else {
                //跳转至首页
                console.log('跳转至首页1');
                next('/')
            }
        })
    }
    if (to.path === '/register') {
        //判断是否可以email注册
        Axios.get(serverUrl + '/api/configsystem/getbyname', {
            params: {
                name: 'register_type'
            }
        }).then(function (r) {
            if (r.data.data.value === 1) {
                //允许手机注册
                next()
            } else {
                //跳转至首页
                console.log('跳转至首页2');
                next('/')
            }
        })
    }
    next()
})

router.afterEach(() => {
    // NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js